import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getcrossProductThunk = createAsyncThunk(
    'product/crossProduct',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.getcrossProduct(data);
            //   console.log(response?.data);

            return response.data;
        } catch (error) {
          return  toast.error(error?.response?.data?.message || "something went wrong")
        }
    }
);

export const compareProductThunk = createAsyncThunk(
    'product/compareProductThunk',
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.compareProduct(data);
            console.log(response?.data);

            return response.data?.data;
        } catch (error) {
            console.log(error);

        }
    }
);

const crossReferenceSlice = createSlice({
    name: 'crossProducts',
    initialState: {
        products: [],
        loading: false,
        page: 1,
        compareProduct: [],
        search: '',
        status: false,
        stock: false,
        selectedData: [],
    },
    reducers: {
        setcrossProductPage: (state, action) => {
            state.page = action.payload
        },
        setCrossCompareProduct: (state, action) => {
            state.compareProduct = action.payload
        },
        deletecrossCompareproduct: (state, action) => {
            state.compareProduct = state.compareProduct.filter((product) => product?._id != action.payload)
        },
        setcrossSearch: (state, action) => {
            state.search = action.payload
        },
        setcrossStatus: (state, action) => {
            state.status = !state.status
        },
        setcrossStock: (state, action) => {
            state.stock = !state.stock
        },
        setCrossProducts:(state,action)=>{
              state.products = []
        },
        togglecrossProductSelection: (state, action) => {
            const product = action.payload;
            const isAlreadySelected = state.selectedData.some((p) => p._id === product._id);

            if (isAlreadySelected) {
                state.selectedData = state.selectedData.filter((p) => p._id !== product._id);
            } else {
                state.selectedData.push(product?._id);
            }
        },
        setSelectedData: (state, action) => {
            state.selectedData = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getcrossProductThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getcrossProductThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.products = action.payload;
            })
            .addCase(getcrossProductThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            //compare
            .addCase(compareProductThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(compareProductThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.compareProduct = action.payload;
            })
            .addCase(compareProductThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })


    },
});

export const { setcrossProductPage, setCompareProduct, deleteCompareproduct, setcrossSearch, setcrossStatus, setcrossStock,togglecrossProductSelectionn,setCrossProducts } = crossReferenceSlice.actions
export default crossReferenceSlice.reducer;